import React, { useState, useEffect, useCallback } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Swal from "sweetalert2/dist/sweetalert2.js";
import { getOperatorLabel } from '../../FormatDuplication/FormatDuplicationCondition/operatorsByType';
import FormCreate from './FormCreate';

const TOKEN = document.querySelector("[name='csrf-token']")?.content;
const REFERENCE_TYPES = ['answer_user_id', 'proceso_id', 'position_id'];

function ModalIndex({ modal, toggle, backdrop, title, configuration_format, type_email, formato, users, procesos, cargos }) {
  const [data, setData] = useState([]);
  const [showPopover, setShowPopover] = useState(false);
  const [editCondition, setEditCondition] = useState(null);

  const loadData = useCallback(() => {
    fetch(`/formatos/get_configuration_format_conditions/${configuration_format.id}/${type_email}`, {
      method: 'GET', headers: { "X-CSRF-Token": TOKEN, "Content-Type": "application/json" }
    })
      .then(r => r.json())
      .then(d => setData(d.data));
  }, [configuration_format.id, type_email]);

  useEffect(() => { loadData(); }, [loadData]);

  const handleCreated = (record) => {
    setData(prev => [...prev, record]);
  };

  const handleUpdated = (record) => {
    setData(prev => prev.map(item => item.id === record.id ? record : item));
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Estas seguro?",
      text: "El registro sera eliminado para siempre!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#009688",
      cancelButtonColor: "#d33",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar"
    }).then(result => {
      if (result.value) {
        fetch(`/formatos/configuration_format_conditions/${id}`, {
          method: "delete", headers: { "X-CSRF-Token": TOKEN, "Content-Type": "application/json" }
        })
          .then(r => r.json())
          .then(resp => {
            setData(prev => prev.filter(item => item.id !== id));
            Swal.fire({ position: "center", type: resp.type, title: resp.success, showConfirmButton: false, timer: 1500 });
          });
      }
    });
  };

  const closePopover = () => {
    setShowPopover(false);
    setEditCondition(null);
  };

  const getDisplayValue = (cond) => {
    if (REFERENCE_TYPES.includes(cond.question.question_type)) {
      return cond.value?.name || cond.value;
    }
    if (cond.value && typeof cond.value === 'string' && cond.value.includes(',')) {
      return cond.value.split(',').join(' y ');
    }
    return cond.value;
  };

  const addBtnId = `add-condition-${type_email}`;

  return (
    <Modal isOpen={modal} toggle={toggle} className="modal-dialog-centered modal-lg" backdrop={backdrop}>
      <ModalHeader toggle={toggle}><i className="app-menu__icon fa fa-user mr-2"></i> {title}</ModalHeader>

      <ModalBody>
        <div style={{ padding: '8px 16px', borderBottom: '1px solid #e5e7eb' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
            <span style={{ fontSize: 12, fontWeight: 600, color: '#666' }}>Condiciones ({data.length})</span>
            <button
              id={addBtnId}
              className="btn btn-info btn-sm"
              onClick={() => { setEditCondition(null); setShowPopover(!showPopover); }}
            >
              <i className="fas fa-plus mr-1" /> Condicion
            </button>
          </div>

          {showPopover && !editCondition && (
            <FormCreate
              isOpen={true}
              target={addBtnId}
              configuration_format_id={configuration_format.id}
              type_email={type_email}
              formatId={formato.id}
              modeEdit={false}
              condition={null}
              existingConditionsCount={data.length}
              onCreated={handleCreated}
              onUpdated={handleUpdated}
              onClose={closePopover}
              users={users}
              procesos={procesos}
              cargos={cargos}
            />
          )}
        </div>

        <div style={{ padding: '8px 16px' }}>
          {data.length > 0 ? (
            <div style={{ fontSize: 13 }}>
              {data.map((cond, idx) => (
                <div key={cond.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 0', borderBottom: '1px solid #f0f0f0' }}>
                  {idx > 0 ? (
                    <span style={{ fontSize: 11, fontWeight: 600, color: cond.conditional === 'O' ? '#e67e22' : '#3498db', minWidth: 24 }}>
                      {cond.conditional === 'O' ? 'O' : 'Y'}
                    </span>
                  ) : (
                    <span style={{ minWidth: 24 }} />
                  )}
                  <span style={{ fontWeight: 500 }}>{cond.question.question}</span>
                  <span style={{ color: '#999', fontSize: 11 }}>{getOperatorLabel(cond.operation)}</span>
                  <span style={{ color: '#27ae60', fontWeight: 500 }}>"{getDisplayValue(cond)}"</span>

                  <div style={{ marginLeft: 'auto', display: 'flex', gap: 4 }}>
                    {editCondition && editCondition.id === cond.id && (
                      <FormCreate
                        isOpen={true}
                        target={`edit-cond-${cond.id}`}
                        configuration_format_id={configuration_format.id}
                        type_email={type_email}
                        formatId={formato.id}
                        modeEdit={true}
                        condition={cond}
                        existingConditionsCount={data.length}
                        onCreated={handleCreated}
                        onUpdated={handleUpdated}
                        onClose={closePopover}
                        users={users}
                        procesos={procesos}
                        cargos={cargos}
                      />
                    )}
                    <button
                      className="btn btn-sm p-0"
                      id={`edit-cond-${cond.id}`}
                      onClick={() => { setEditCondition(cond); setShowPopover(true); }}
                    >
                      <i className="fas fa-pencil-alt" style={{ color: '#999', cursor: 'pointer', fontSize: 12 }} />
                    </button>
                    <button className="btn btn-sm p-0" onClick={() => handleDelete(cond.id)}>
                      <i className="fas fa-trash-alt" style={{ color: '#999', cursor: 'pointer', fontSize: 12 }} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '8px 0', color: '#999', fontSize: 12 }}>
              Sin condiciones — se enviara siempre
            </div>
          )}
        </div>
      </ModalBody>

      <ModalFooter>
        <label className="btn btn-light mt-2" onClick={toggle}>Cerrar</label>
      </ModalFooter>
    </Modal>
  );
}

export default ModalIndex;
